// GeneralDataContext.ts
import React from 'react';

// Define the shape of general data from ACF options
// The API returns { acf: {...} }, and we extract the acf object
export interface WebsiteGeneralData {
  [key: string]: any; // ACF fields can be of various types
}

// Define the shape of the context value
interface GeneralDataContextType {
  data: WebsiteGeneralData | null;
  loading: boolean;
  initialLoading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export const defaultContextValue: GeneralDataContextType = {
  data: null,
  loading: false,
  initialLoading: true,
  error: null,
  refresh: async () => {},
};

// Create the context
const GeneralDataContext = React.createContext<GeneralDataContextType>(defaultContextValue);

export { GeneralDataContext };